import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.375 1a3.29 3.29 0 0 0-3.292 3.292v8.753c0 2.109 2.543 3.172 4.044 1.69l2.248-2.22a.83.83 0 0 1 .586-.24h5.747A3.29 3.29 0 0 0 17 8.984V4.292A3.29 3.29 0 0 0 13.708 1zM18.5 10c0-.883.823-1 1.5-1a3 3 0 0 1 3 3v8.787c0 2.109-2.543 3.172-4.044 1.69l-2.248-2.22a.83.83 0 0 0-.585-.24h-4.831A3.29 3.29 0 0 1 8 16.727V15a1 1 0 0 1 1-1h5.5c2.18 0 3.098-.843 3.527-1.53.234-.375.355-.757.416-1.049.075-.362.068-.73.061-1.098z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a = { render: r };
export {
  a as default,
  r as render
};
//# sourceMappingURL=ic_chat_filled-CSUAYyT9.js.map
